import { Box, Chip } from '@mui/material'
import { GridColumns } from '@mui/x-data-grid'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Table } from 'src/components/Table/Table'
import { AlertContext } from 'src/context/AlertContext'
import { CreateApiKey } from '../../CreateApiKey'
import { ROUTES } from 'src/routes/Router'
import { getApiKeys, deleteApiKeyById } from 'src/service/apiKeysService'
import { getPermissions } from 'src/service/authService'
import { StringSort } from 'src/components/Table/SortingFunctions'
import { getExpirationDate } from 'src/util/generate-expiration-date'

export default function ApiKeysTable() {
  const { t } = useTranslation()
  const { createCRUDAlert } = useContext(AlertContext)
  const [tableKey, setTableKey] = useState(0)
  const permissions = JSON.parse(getPermissions())

  const getData = async (options) => {
    const data = await getApiKeys(options)
    return {
      data: data?.items,
      totalPages: data?.meta?.totalPages,
      size: data?.meta?.size,
    }
  }

  const handleDelete = async (id, name) => {
    const res = await deleteApiKeyById(id)
    if (res) {
      createCRUDAlert(ROUTES.APIKEYS, name, 'deleted')
    }
  }

  const columns: GridColumns = [
    {
      field: 'name',
      headerName: t('table.header.api_name'),
      width: 125,
      editable: false,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'keyHash',
      headerName: t('table.header.api_key'),
      width: 125,
      editable: false,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'companyName',
      headerName: t('table.header.company'),
      width: 150,
      type: 'number',
      editable: false,
      headerAlign: 'left',
      align: 'left',
      valueGetter: ({ row }) => row?.company?.name || '',
      sortComparator: StringSort,
    },
    {
      field: 'createdByName',
      headerName: t('table.header.created_by'),
      width: 150,
      type: 'number',
      editable: false,
      headerAlign: 'left',
      align: 'left',
      valueGetter: ({ row }) => row?.createdBy?.name || '',
      sortComparator: StringSort,
    },
    {
      field: 'expiresAt',
      headerName: t('table.header.expires_at'),
      width: 150,
      type: 'number',
      editable: false,
      headerAlign: 'left',
      align: 'left',
      valueGetter: ({ row }) => {
        const info = getExpirationDate(row?.expiresAt || undefined)
        if (info.type === 'i18n') return t(info.value)
        return info.value
      }
    },
  ]

  return (
    <Box sx={{ mb: 4 }}>
      <Table
        columns={columns}
        getData={getData}
        key={tableKey}
        handleDelete={handleDelete}
        titleKey="name"
        goTo={null}
        defaultPageSize={15}
        model={'apikey'}
        DetailComponent={CreateApiKey}
        size={'24px'}
        mr="25px"
        permissionUpdate={true}
        permissionDelete={!permissions?.apikey?.includes("apikey:revoke")}
        permissionView={true}
        canShowRecycleButtons={false}
        permissionViewRecycle={false}
        permissionUpdateRecycle={false}
        canShowUnarchiveButtons={false}
        shouldHideAuditory={true}
      />
    </Box>
  )
}
